/*
 *   File : success-modal.jsx
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations :
 *   Version : 1.0.0
 */

import React from "react";
import { PrimaryButton } from "../Cta";
import image from "../../Assets/Image/success.png";
export default function SuccesModal({
  close,
  onClick,
  message,
  title,
  type,
  buttonName,
}) {
  return (
    <div className=" position-fixed top-0 start-0 e-bg-modal min-h-100vh min-vw-100 d-flex align-items-center justify-content-center">
      <div className="row w-100">
        <div className="offset-4 col-lg-5">
          <div className="bg-white e-border-radius-24 p-3">
            <div className="d-flex justify-content-end">
              <PrimaryButton
                icon="close-button"
                name=""
                ClassName="bg-white"
                onPress={close}
              />
            </div>
            <div className="d-flex justify-content-center">
              <img
                src={image}
                alt="success Modal"
                style={{ width: "200px", height: "auto" }}
              />
            </div>
            <h5 className=" text-center e-font-weight-600 e-font-20 line-height-32px e-primary-font-poppins">
              {title}
            </h5>
            <div className="row">
              <div className=" offset-1 col-10">
                <p className=" e-font-16 text-center e-font-weight-400 e-primary-font-poppins line-height-24px">
                  {message
                    ? message
                    : "Lorem ipsum dolor sit amet consectetur. Eu risus purus suspendisse leo pellentesque blandit id tellus."}
                </p>
              </div>
            </div>
            {type === 2 && (
              <div className="row">
                <div className="col-12">
                  <div className="d-flex e-bg-cultured w-100 e-border-radius-16 p-3">
                    <div className="row ">
                      <div className="col-2 d-flex flex-column justify-content-center">
                        <img
                          style={{ width: "40px" }}
                          src={require("../../Assets/Image/bank.png")}
                          alt=""
                        />
                      </div>
                      <div className="col-10">
                        <p className="e-primary-font-poppins e-text-eerie-black e-font-16 e-font-weight-400 m-0">
                          Axis Bank
                        </p>
                        <p className="e-primary-font-poppins e-text-granite-gray e-font-12 e-font-weight-400 m-0">
                          ...9204
                        </p>
                        <p className="e-primary-font-poppins e-text-granite-gray e-font-12 e-font-weight-400 m-0">
                          Aman Qureshi IFSC:AXBK00001234
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="row pt-4">
              <div className="col">
                <PrimaryButton
                  ClassName="e-border-radius-pill e-font-weight-500 e-font-16 w-100 e-bg-blue-violet text-white e-primary-font-poppins"
                  name={buttonName ? buttonName : " Ok"}
                  onPress={onClick}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
